import { COMPONENT_TYPES } from '../../../constants';
import CartComponent from './Cart.component';
import CartEditor from './Cart.editor';
import CartProperties from './Cart.properties';
import { registerComponent, registerPropertyPanel } from '../registry';

// 레지스트리에 Cart 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.CART,
  component: CartComponent,
  editorComponent: CartEditor,
  properties: undefined,
  defaultProps: {
    title: '장바구니',
    emptyText: '장바구니가 비어 있습니다.',
    shippingFee: 4000,
    showStock: false,
    style: {
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      maxWidth: '1200px',
      margin: '30px auto'
    }
  },
  category: 'ecommerce',
  icon: '🛒',
  name: '장바구니'
});

// 속성 패널 등록
registerPropertyPanel(COMPONENT_TYPES.CART, CartProperties);

// 컴포넌트 및 타입 내보내기
export { default as CartComponent } from './Cart.component';
export { default as CartEditor } from './Cart.editor';
export { default as CartProperties } from './Cart.properties';
export * from './Cart.types';
export * from './Cart.adapter'; 